import React from 'react';

const Input = ({ 
  className = '',
  placeholder = '',
  as = 'input',
  ...props 
}) => {
  const baseStyles = 'h-14 md:h-24 w-full bg-transparent border-b-2 border-border text-2xl md:text-4xl font-bold uppercase tracking-tighter text-foreground px-0 py-2 md:py-4 rounded-none transition-colors duration-200 focus:outline-none focus:border-accent placeholder:text-muted placeholder:uppercase';
  
  if (as === 'textarea') {
    return (
      <textarea
        className={`${baseStyles} min-h-[80px] md:min-h-[120px] resize-none ${className}`}
        placeholder={placeholder}
        {...props}
      />
    );
  }
  
  return (
    <input
      type="text"
      className={`${baseStyles} ${className}`}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default Input;

